module.exports = __webpack_public_path__ + "static/media/carta_41.61be53d7.jpg";